import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing }) => ({
  icon: {
    color: "#757575",
  },
  input: {
    marginBottom: spacing(2.5),
  },
}));
